import { createFileRoute, Link } from "@tanstack/react-router";
import { BLOGS } from "@/lib/blogs";
import { BackButton } from "@/components/site/BackButton";

export const Route = createFileRoute("/journal/")({
  head: () => ({
    meta: [
      { title: "The Journal — KAKAIYS" },
      {
        name: "description",
        content:
          "Notes from the maison: leather care, fit guides, style essays, and the heritage of the leather jacket. Long reads from KAKAIYS.",
      },
      { property: "og:title", content: "The Journal — KAKAIYS" },
      {
        property: "og:description",
        content: "Notes from the maison: care, fit, style, heritage.",
      },
      { property: "og:image", content: BLOGS[0].hero },
      { name: "twitter:image", content: BLOGS[0].hero },
    ],
      links: [{ rel: "canonical", href: "https://kakaiys.com/journal" }],
  }),
  component: JournalPage,
});

function JournalPage() {
  const [hero, ...rest] = BLOGS;
  return (
    <>
      <section className="pt-32 md:pt-40 pb-12 container-luxe text-center">
        <BackButton fallback="/" className="mb-8" />
        <div className="eyebrow mb-4 text-gold">The Journal</div>
        <h1 className="font-serif text-5xl md:text-7xl">
          Notes from the <span className="italic text-gradient-gold text-slate-50">maison.</span>
        </h1>
        <p className="mt-6 max-w-xl mx-auto text-sm md:text-base text-muted-foreground">
          Long reads on leather, fit, style and the quiet heritage of the jacket — written
          by the people who make them.
        </p>
      </section>

      {/* HERO BLOG */}
      <section className="container-luxe pb-12 md:pb-20">
        <Link
          to="/journal/$slug"
          params={{ slug: hero.slug }}
          preload="intent"
          className="group block"
        >
          <div className="grid md:grid-cols-[1.3fr_1fr] gap-8 md:gap-14 items-center">
            <div className="relative aspect-[5/4] md:aspect-[4/3] overflow-hidden img-frame">
              <img
                src={hero.hero}
                alt={hero.title}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div>
              <div className="eyebrow text-gold mb-4">{hero.category} · {hero.readMinutes} min read</div>
              <h2 className="font-serif text-3xl md:text-5xl leading-tight group-hover:text-gold transition-colors">
                {hero.title}
              </h2>
              <p className="mt-5 text-muted-foreground leading-relaxed">{hero.excerpt}</p>
              <span className="mt-8 inline-flex text-[11px] uppercase tracking-[0.28em] text-gold border-b border-gold/60 pb-1">
                Read the Essay →
              </span>
            </div>
          </div>
        </Link>
      </section>

      {/* GRID */}
      <section className="container-luxe pb-24 md:pb-32 border-t border-border pt-16">
        <div className="grid md:grid-cols-3 gap-10 md:gap-12">
          {rest.map((b) => (
            <Link
              key={b.slug}
              to="/journal/$slug"
              params={{ slug: b.slug }}
              preload="intent"
              className="group block"
            >
              <div className="relative aspect-[4/5] overflow-hidden img-frame mb-6">
                <img
                  src={b.hero}
                  alt={b.title}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="eyebrow text-gold mb-2">{b.category} · {b.readMinutes} min</div>
              <h3 className="font-serif text-2xl leading-tight group-hover:text-gold transition-colors">
                {b.title}
              </h3>
              <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{b.excerpt}</p>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
